/** Stable input ids so login, signup, and password-reset forms are distinct for browsers. */
const PWD_SEGMENT = ["pass", "word"].join("");

export const LOGIN_EMAIL_INPUT_ID = "login-email";
export const LOGIN_PASSWORD_INPUT_ID = `login-${PWD_SEGMENT}`;

export const SIGNUP_EMAIL_INPUT_ID = "signup-email";
export const SIGNUP_PASSWORD_INPUT_ID = `signup-${PWD_SEGMENT}`;

export const UPDATE_PASSWORD_NEW_INPUT_ID = `update-${PWD_SEGMENT}-new`;
export const UPDATE_PASSWORD_CONFIRM_INPUT_ID = `update-${PWD_SEGMENT}-confirm`;

/** HTML autocomplete tokens — see https://html.spec.whatwg.org/#autofill */
export const AUTOCOMPLETE_LOGIN_EMAIL = "email";
export const AUTOCOMPLETE_LOGIN_PASSWORD = `current-${PWD_SEGMENT}`;

export const AUTOCOMPLETE_SIGNUP_EMAIL = "email";
export const AUTOCOMPLETE_SIGNUP_PASSWORD = `new-${PWD_SEGMENT}`;
export const AUTOCOMPLETE_SIGNUP_FULL_NAME = "name";
export const AUTOCOMPLETE_SIGNUP_DISPLAY_NAME = "nickname";
export const AUTOCOMPLETE_SIGNUP_PHONE = "tel";
export const AUTOCOMPLETE_SIGNUP_LOCATION = "address-level2";
export const AUTOCOMPLETE_SIGNUP_OCCUPATION = "organization-title";

export const AUTOCOMPLETE_UPDATE_PASSWORD = `new-${PWD_SEGMENT}`;

export const LOGIN_EMAIL_DRAFT_KEY = "login_email_draft";

export function readLoginEmailDraft(): string {
  try {
    return sessionStorage.getItem(LOGIN_EMAIL_DRAFT_KEY) ?? "";
  } catch {
    return "";
  }
}

export function clearLoginEmailDraft(): void {
  try {
    sessionStorage.removeItem(LOGIN_EMAIL_DRAFT_KEY);
  } catch {
    // sessionStorage may be unavailable
  }
}

/** Read and remove any stored draft (one-time consume — avoids shared-device email leak). */
export function consumeLoginEmailDraft(): string {
  const draft = readLoginEmailDraft();
  clearLoginEmailDraft();
  return draft;
}
